// @core/api/endpoints/license/revoke_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
  RevokeLicenseRequest,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Revoke license
 * Permanently revokes a license. The license cannot be reactivated after revocation. Master-only operation.
 */
export async function RevokeLicense(
  license_id: string,
  data: RevokeLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/revoke`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
